import { useAtom } from "jotai";
import { usersDialogAtom, usersCurrentRowAtom } from "../store/users-atom";
import { UsersDeleteAllDialog } from "./users-delete-all-dialog";
import { UsersDeleteDialog } from "./users-delete-dialog";
import { UsersInviteDialog } from "./users-invite-dialog";

export function UsersDialogs() {
  const [open, setOpen] = useAtom(usersDialogAtom);
  const [currentRow, setCurrentRow] = useAtom(usersCurrentRowAtom);

  return (
    <>
      <UsersInviteDialog
        key="user-invite"
        open={open === "invite"}
        onOpenChange={() => setOpen(open === "invite" ? null : "invite")}
      />

      {currentRow && (
        <UsersDeleteDialog
          key={`user-delete-${currentRow.id}`}
          open={open === "delete"}
          onOpenChange={() => {
            setOpen(open === "delete" ? null : "delete");
            setTimeout(() => setCurrentRow(null), 500);
          }}
          currentRow={currentRow}
        />
      )}

      <UsersDeleteAllDialog
        key="user-delete-all"
        open={open === "delete_all"}
        onOpenChange={() =>
          setOpen(open === "delete_all" ? null : "delete_all")
        }
      />
    </>
  );
}
